module.exports = __webpack_public_path__ + "img/carousel-pandistelle.png?fdfaf5b6f7e9a514e58da0c771446501";